import { SupportedFeatures } from '@/helpers/featureFlagUtils';

export enum ListingInsightsTabId {
  Actions = 'actions',
  Performance = 'performance',
  Price = 'price',
  ListingHistory = 'listing-history',
  SimilarListings = 'similar-listings',
  /** Implemented but hidden until product enables it. */
  Ranking = 'ranking',
  /** Implemented but hidden until product enables it. */
  Leads = 'leads',
}

export const LISTING_INSIGHTS_ENABLED_TAB_IDS: ListingInsightsTabId[] = [
  ListingInsightsTabId.Actions,
  ListingInsightsTabId.Performance,
  ListingInsightsTabId.Price,
];

export interface ListingInsightsNewTabDefinition {
  tabId: ListingInsightsTabId;
  featureFlag?: SupportedFeatures;
}

export const LISTING_INSIGHTS_NEW_TABS: ListingInsightsNewTabDefinition[] = [
  { tabId: ListingInsightsTabId.SimilarListings },
  { tabId: ListingInsightsTabId.Ranking, featureFlag: SupportedFeatures.SHOW_RANKING_EXPLAINER },
];

export const LISTING_INSIGHTS_NEW_TAB_IDS: ListingInsightsTabId[] = LISTING_INSIGHTS_NEW_TABS.map(
  ({ tabId }) => tabId,
);

type FeatureFlagChecker = (feature: SupportedFeatures) => boolean;

/**
 * Returns the default tabs plus new tabs (and feature-flagged new tabs when enabled).
 */
export function buildEnabledListingInsightsTabIds(
  isFeatureEnabled: FeatureFlagChecker,
): ListingInsightsTabId[] {
  const tabs = [...LISTING_INSIGHTS_ENABLED_TAB_IDS];

  for (const { tabId, featureFlag } of LISTING_INSIGHTS_NEW_TABS) {
    if (featureFlag !== undefined && !isFeatureEnabled(featureFlag)) {
      continue;
    }
    tabs.push(tabId);
  }

  tabs.push(ListingInsightsTabId.ListingHistory);
  return tabs;
}

export const LISTING_INSIGHTS_TAB_LABEL_KEYS: Record<ListingInsightsTabId, string> = {
  [ListingInsightsTabId.Actions]: 'performanceDetails.tabs.actions',
  [ListingInsightsTabId.Performance]: 'performanceDetails.tabs.performance',
  [ListingInsightsTabId.Price]: 'performanceDetails.tabs.price',
  [ListingInsightsTabId.ListingHistory]: 'performanceDetails.tabs.listingHistory',
  [ListingInsightsTabId.SimilarListings]: 'performanceDetails.tabs.similarListings',
  [ListingInsightsTabId.Ranking]: 'performanceDetails.tabs.ranking',
  [ListingInsightsTabId.Leads]: 'performanceDetails.tabs.leads',
};
